<ca-modal-container
    modalTitle="{{ 'MODULES.CREATOR.TITLE' | translate }}"
    description="{{ 'MODULES.CREATOR.MODULE' | translate }}"
    (dismiss)="dismiss('Canceled')"
>
    <form [formGroup]="formGroup" (ngSubmit)="submit()" novalidate>
        <div>
            <input
                type="text"
                class="form-control"
                formControlName="name"
                placeholder="Module Title"
                required
                data-uit="create-module-name"
                [ngClass]="formGroup.get('name')?.errors && formGroup.get('name')?.dirty ? 'has-error' : ''"
            />
            <small *ngIf="formGroup.get('name')?.dirty && formGroup.get('name')?.hasError('required')" class="invalid-feedback">
                {{ 'GENERAL.REQUIRED_FIELD' | translate }}
            </small>
            <small *ngIf="formGroup.get('name')?.dirty && formGroup.get('name')?.hasError('pattern')" class="invalid-feedback">
                {{ 'MODULES.CREATOR.ERROR_MODULE_TITLE' | translate }}
            </small>
        </div>
        <div hidden><textarea class="form-control" formControlName="description" placeholder="Module Description"></textarea></div>
        <div class="dropdown my-3">
            <ng-select
                formControlName="moduleExampleId"
                placeholder="{{ placeHolderValue }}"
                appendTo="body"
                [searchable]="false"
                [clearable]="false"
                data-uit="create-module-example-selector"
            >
                <ng-option value="null">{{ 'MODULES.CREATOR.EMPTY_MODULE' | translate }}</ng-option>
                <ng-option *ngFor="let example of moduleExamples" [value]="example.id">{{ example.name }}</ng-option>
            </ng-select>
            <small *ngIf="formGroup.get('moduleExampleId')?.hasError('required') && formGroup.get('moduleExampleId')?.dirty" class="invalid-feedback">
                {{ 'GENERAL.REQUIRED_FIELD' | translate }}
            </small>
        </div>
        <div class="modal-buttons pb-3">
            <button type="submit" caAutoFocus class="btn btn-primary" [disabled]="!formGroup.valid || isSubmitting" data-uit="create-module-create-button">
                {{ 'MODULES.CREATOR.CREATE_MODULE_BUTTON' | translate }}
            </button>
        </div>
    </form>
</ca-modal-container>
